import CoverageNonLiabilityLinkModal from '@root/quotes/src/components/modals/coverage-non-liability-link-modal';
import PropTypes from '@root/vendor/prop-types';
import React from '@root/vendor/react';
import { StyleSheet, Theme } from '@root/core/src/utils/styles';

const NjPipPrimaryInsurerLearnMoreModal = ({
  primaryBrandColor,
  infoBrandColor,
}) => (
  <CoverageNonLiabilityLinkModal
    infoBrandColor={infoBrandColor}
    linkText={'Learn more'}
    modalName={'NJ PIP Primary Insurer Learn More Modal'}
    primaryBrandColor={primaryBrandColor}
  >
    <h2 css={styles.header}>Primary insurer</h2>
    <p css={styles.paragraph}>In New Jersey, you get to decide whether your health insurance or Root pays your medical bills if you&apos;re injured in a car accident.</p>
    <p css={styles.paragraph}><strong>If you&apos;re unsure about your health plan&apos;s coverage, have Medicare, Medicaid, or Tri-care, select Root.</strong></p>
    <p css={styles.paragraph}>Some health insurance plans may limit or deny coverage for car accident injuries.</p>
    <p css={styles.paragraph}>
      If your health insurance doesn&apos;t cover it, you&apos;ll have to pay an extra $750 deductible before your Root PIP coverage applies.
    </p>
  </CoverageNonLiabilityLinkModal>
);

NjPipPrimaryInsurerLearnMoreModal.propTypes = {
  infoBrandColor: PropTypes.string,
  primaryBrandColor: PropTypes.string,
};

export default NjPipPrimaryInsurerLearnMoreModal;

const styles = StyleSheet.create({
  header: {
    ...Theme.heading2(),
    marginBottom: 24,
  },
  paragraph: {
    ...Theme.paragraph1(),
    marginBottom: 12,
  },
});
